

<div *ngIf="!loggedIn" id="recuadroLogin">
  <div id="secBtn">
    <form class="btnMenu manual" onclick="verManual()">
      <button style="text-decoration:none">
        Ver manual
      </button>
    </form >
    <div class="btnMenu login">
      <button (click)="login()" style="text-decoration:none;" class="btnMenu" name="login" value="Iniciar Sesión">Iniciar sesión</button>
    </div>
  </div>
</div>

<router-outlet *ngIf="loggedIn"></router-outlet>
